import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/about", label: "About Us", testid: "nav-about-link" },
  { to: "/destinations", label: "Destinations", testid: "nav-destinations-link" },
  { to: "/services", label: "Travel Services", testid: "nav-services-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-ocean/10 bg-white/80 backdrop-blur-md">
      <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6">
        <Link to="/" aria-label="Arora Travel Online — home">
          <Logo />
        </Link>

        <div className="hidden items-center gap-8 lg:flex">
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={link.testid}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-turquoise" : "text-ink/70 hover:text-ocean"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/plan-your-trip"
            data-testid="nav-plan-trip-link"
            className="rounded-full bg-coral px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-coral/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#B01A23]"
          >
            Plan Your Trip
          </Link>
        </div>

        <button
          type="button"
          data-testid="mobile-menu-button"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-full text-ocean lg:hidden"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden border-t border-ocean/10 bg-white/95 backdrop-blur-md lg:hidden"
          >
            <div className="flex flex-col gap-1 px-4 py-4">
              {LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  data-testid={`mobile-${link.testid}`}
                  className={({ isActive }) =>
                    `rounded-xl px-4 py-3 text-sm font-medium ${
                      isActive ? "bg-sand text-ocean" : "text-ink/70"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <Link
                to="/plan-your-trip"
                data-testid="mobile-nav-plan-trip-link"
                className="mt-2 rounded-full bg-coral px-4 py-3 text-center text-sm font-semibold text-white"
              >
                Plan Your Trip
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
